module.exports = "<edit-header>\n  <a *ngIf=\"canWriteDrivers && type === 'drivers' || canWriteModules && type === 'modules'\" [routerLink]=\"['./new-family']\" class=\"sg-btn sg-blue\">Add</a>\n</edit-header>\n\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/drilldown/drilldown.component.html
// module id = ./src/app/drilldown/drilldown.component.html
// module chunks = main